import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "delivery-chapter" }


import DeliveryQuestionCard from '@/views/delivery/cards/DeliveryQuestionCard.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DeliveryChaptersCard',
  props: {
    chapter: null,
    room: null,
    lastItem: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { chapter: { id:number, name:string, questions: { id:number }[] }, room:{ id:number, level:number }, lastItem:boolean };



return (_ctx: any,_cache: any) => {
  const _component_a_divider = _resolveComponent("a-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", null, _toDisplayString(__props.chapter.name), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.chapter.questions, (q, i) => {
      return (_openBlock(), _createBlock(DeliveryQuestionCard, {
        question: q,
        room: __props.room,
        lastItem: i === __props.chapter.questions.length - 1,
        key: q.id
      }, null, 8, ["question", "room", "lastItem"]))
    }), 128)),
    (!__props.lastItem)
      ? (_openBlock(), _createBlock(_component_a_divider, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})